import type { ReactNode } from 'react';

export const symbol_editor_choice: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-117 329-66q-5 2-9.56 2.5-4.56.5-9.12.5Q286-63 268-79.88 250-96.75 250-123v-260L141-558q-5-8-6.5-15.81-1.5-7.82-1.5-16 0-8.19 1.5-16.19 1.5-8 6.5-16l142-230q8-14 21.58-21 13.58-7 29.42-7h292q15.84 0 29.42 7Q669-866 677-852l142 230q5 8 6.5 15.81 1.5 7.82 1.5 16 0 8.19-1.5 16.19-1.5 8-6.5 16L710-383v260q0 26.25-18.14 43.12Q673.72-63 649.53-63q-4.53 0-9.03-.5Q636-64 631-66l-151-51Zm0-62 170 55v-176H310v176l170-55ZM333.88-360H626l142-230-141.88-230H334L192-590l141.88 230ZM438-526l148-149q9-9 21-9t21 8.61q9 9.39 9.5 21.86.5 12.46-8.5 21.53L459-462q-9 9-21 9t-21-9l-85-85q-9-9-9.5-21t8.5-21q9-9 21.83-9 12.84 0 22.17 9l63 63Zm42 226H310h340-170Z"
		/>
	</svg>
);
